import { tableCellClasses } from '@mui/material/TableCell';
import theme from 'assets/style/theme';

const ipamAdminStyle = {
    pageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0',
    },
    pageTitle: {
        fontSize: '22px',
        fontWeight: 700,
        color: '#1E1E1E',
    },
    sectionDropdown: {
        minWidth: '160px',
    },
    filterBtn: {
        height: '38px',
        width: '100px',
        color: theme.palette.blue.strongDark,
        backgroundColor: theme.palette.background.$color_background_layer_02,
        border: '1px solid #D7E5F8',
        borderRadius: theme.palette.border.$border_radius,
        fontSize: '13px',
        fontWeight: 600,
        textTransform: 'none',
        '&:hover': {
            color: theme.palette.blue.strongDark,
            border: '1px solid #D7E5F8',
            backgroundColor: theme.palette.button.$color_buttongroup_default,
        },
    },
    filterPopper: {
        wrapper: {
            background: '#fff',
            width: 280,
            padding: '16px',
            position: 'relative',
            top: 8,
        },
        arrow: {
            position: 'absolute',
            fontSize: 60,
            top: -34,
            right: 20,
            fill: '#fff',
            zIndex: -1,
        },
        closeRow: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '8px',
        },
        closeIcon: {
            cursor: 'pointer',
            color: '#666',
            '&:hover': { color: '#333' },
        },
        resetBtn: {
            color: '#003d8c',
            fontSize: '13px',
            fontWeight: 600,
            textTransform: 'none',
        },
        applyBtn: {
            backgroundColor: '#003d8c',
            fontSize: '13px',
            fontWeight: 600,
            textTransform: 'none',
            minWidth: '80px',
            '&:hover': { backgroundColor: '#002a6e' },
        },
    },
    card: {
        marginTop: '10px',
        marginBottom: '24px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0px 1px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden',
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        borderBottom: '1px solid #f0f0f0',
    },
    cardTitle: {
        fontSize: '16px',
        fontWeight: 500,
        color: '#1E1E1E',
        paddingTop: '10px',
        paddingBottom: '2px',
    },
    searchBox: {
        '& .MuiOutlinedInput-root': {
            height: '36px',
            borderRadius: '4px',
            fontSize: '14px',
            '& fieldset': {
                borderColor: '#d0d0d0',
            },
            '&:hover fieldset': {
                borderColor: '#aaa',
            },
        },
        width: '240px',
    },
    filtersRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '12px 20px',
        flexWrap: 'wrap',
    },
    filterSelect: {
        height: '34px',
        borderRadius: '17px',
        fontSize: '13px',
        minWidth: '130px',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d0d0d0',
        },
    },
    allFiltersChip: {
        height: '34px',
        borderRadius: '17px',
        color: '#003d8c',
        fontSize: '13px',
        cursor: 'pointer',
        backgroundColor: '#fff',
        fontWeight: 600,
        padding: '0 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
    resetAllBtn: {
        fontSize: '13px',
        color: '#003d8c',
        cursor: 'pointer',
        background: 'none',
        fontWeight: 600,
        border: 'none',
        padding: 0,
        '&:hover': { color: '#003d8c' },
    },
    addBtn: {
        marginLeft: 'auto',
        backgroundColor: '#fff',
        color: '#003d8c',
        border: '1.5px solid #003d8c',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 600,
        padding: '7px 18px',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
    },
    tableContainer: {
        overflowX: 'auto',
        marginTop: theme.spacing(0.5),
        borderRadius: '3px',
        boxShadow: '1px 1px 2px #00000014',
    },
    table: { marginTop: theme.spacing(-1.125), borderSpacing: 0, height: 'auto', width: 'max-content', minWidth: '100%' },
    loadingRow: { background: 'transparent !important' },
    loadingCell: { border: '0 !important' },
    cellContent: { maxWidth: 250, whiteSpace: 'normal', wordBreak: 'break-word' },
    searchIconBtn: { p: '4px' },
    searchClearIcon: { color: '#888', fontSize: '16px' },
    searchIcon: { color: '#888', fontSize: '18px' },
    badge: {
        '& .MuiBadge-badge': { position: 'static', transform: 'none', fontSize: '11px', minWidth: '18px', height: '18px' },
    },
    charts: {
        wrapper: { pb: 2, mb: 2 },
        chartCard: { p: 2, borderRadius: '8px', height: '100%', backgroundColor: '#fff', border: '1px solid #f0f0f0' },
        chartTitle: { fontWeight: 600, fontSize: '14px', color: '#1E1E1E', mb: 1.5 },
        legendStyle: { fontSize: '12px' },
    },
    styledTableCell: {
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.cyan['90'],
            color: theme.palette.blue.strongDark,
            font: theme.typography.fontSize.$font_small_bold,
            padding: '0 13px',
            height: '50px',
            border: 0,
            verticalAlign: 'middle',
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: '13px',
            color: '#1E1E1E',
            borderTop: '1px solid rgba(224, 224, 224, 1)',
            padding: '10px 13px',
            height: '50px',
            verticalAlign: 'middle',
        },
        '&:first-of-type': {
            borderLeft: '1px solid rgba(224, 224, 224, 1)',
        },
        '&:last-child': {
            borderRight: '1px solid rgba(224, 224, 224, 1)',
        },
    },
    styledTableRow: {
        backgroundColor: '#FFFFFF',
        height: '50px',
        '&:hover': {
            backgroundColor: '#eef4fd',
        },
        '&:last-child td, &:last-child th': {},
    },
    pagination: {
        tablePagination: {
            backgroundColor: '#FFFFFF',
            width: 'auto',
            color: '#1E1E1E',
            border: '1px solid #E0E0E0',
            '.MuiTablePagination-spacer': { flex: 0 },
            '.MuiToolbar-root': {
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row-reverse',
                alignItems: 'center',
            },
            '.MuiTablePagination-displayedRows': {
                fontWeight: 500,
                fontSize: '1rem',
                color: '#1E1E1E',
                paddingTop: '2px',
            },
        },
    },
    actionIconBtn: {
        padding: '4px',
        color: '#555',
        '&:hover': { color: '#005CBC' },
    },
    paginationRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 20px',
        borderTop: '1px solid #e0e0e0',
        flexWrap: 'wrap',
        gap: '8px',
    },
    rowsPerPageLabel: {
        fontSize: '13px',
        color: '#555',
        marginRight: '4px',
    },
    rowsPerPageSelect: {
        height: '30px',
        fontSize: '13px',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d0d0d0' },
    },
    paginationControls: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
    },
    pageInput: {
        width: '50px',
        height: '30px',
        textAlign: 'center',
        border: '1px solid #005CBC',
        borderRadius: '4px',
        fontSize: '13px',
        outline: 'none',
        padding: '0 4px',
    },
    pageNavBtn: {
        padding: '4px',
        color: '#555',
        '&:disabled': { color: '#ccc' },
    },
    loadingStack: { width: '100%', height: 'calc(100vh - 100px)' },
    activeChip: {
        true: { backgroundColor: '#EDF7ED', color: '#2E7D32', fontWeight: 600, fontSize: '11px' },
        false: { backgroundColor: '#FDEDED', color: '#D32F2F', fontWeight: 600, fontSize: '11px' },
    },
    chip: {
        critical: { backgroundColor: '#FDEDED', color: '#D32F2F', fontWeight: 600, fontSize: '11px' },
        high: { backgroundColor: '#FFF4E5', color: '#ED6C02', fontWeight: 600, fontSize: '11px' },
        medium: { backgroundColor: '#E8F4FD', color: '#0288D1', fontWeight: 600, fontSize: '11px' },
        low: { backgroundColor: '#EDF7ED', color: '#2E7D32', fontWeight: 600, fontSize: '11px' },
    },
    dialogForm: {
        fieldRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: '6px',
        },
        labelStyle: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '14px',
            fontWeight: 500,
            color: '#1E1E1E',
        },
        requiredStyle: { fontSize: '13px', color: '#1E1E1E' },
        selectSx: {
            width: '100%',
            height: '44px',
            fontSize: '14px',
            color: '#555',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d0d0d0' },
            mb: '16px',
        },
        textFieldSx: {
            mb: '16px',
            '& .MuiOutlinedInput-root': {
                height: '44px',
                fontSize: '14px',
                '& fieldset': { borderColor: '#d0d0d0' },
            },
        },
        textFieldSx0: {
            mb: 0,
            '& .MuiOutlinedInput-root': {
                height: '44px',
                fontSize: '14px',
                '& fieldset': { borderColor: '#d0d0d0' },
            },
        },
    },
};

export default ipamAdminStyle;
